{
  "name": "webshop-driver",
  "version": "1.9.0",
  "private": true,
  "app": "dist/index.js",
  "source": "src/index.ts",
  "dependencies": {
    "@footprint/common-components": "latest",
    "axios": "^1.2.1",
    "env-cmd": "^10.1.0",
    "eventemitter3": "^5.0.0",
    "jsx": "^0.9.89",
    "promise-window": "^1.2.1",
    "react": "19.1.0",
    "react-dom": "19.1.0",
    "react-intl": "8.0.x",
    "react-is": "19.1.0",
    "react-qr-code": "^2.0.7",
    "react-test-renderer": "19.1.0",
    "resize-observer-polyfill": "^1.5.1",
    "styled-components": "^6.1.11",
    "webpack": "5.96.1"
  },
  "license": "ISC",
  "scripts": {
    "lint": "eslint \"{src,apps,libs,test}/**/*.ts\" --fix",
    "tsc": "tsc --noEmit",
    "start": "parcel --no-autoinstall -p 3000 watch index.html --no-hmr",
    "start:host": "NODE_ENV=development parcel --no-autoinstall -p 3000 --host $npm_config_host watch src/index.ts --no-hmr",
    "watch": "npm run build:local && http-server ./dist -p 3000 --cors",
    "build": "env-cmd -f ./.env parcel build src/index.ts",
    "build:testing": "NODE_ENV=development parcel build src/index.ts --public-url \"https://testing-frontend.footprinttech.de\"",
    "build:production": "NODE_ENV=production parcel build src/index.ts --public-url \"https://production-frontend.footprinttech.de\"",
    "build:azure": "NODE_ENV=production parcel build src/index.ts --public-url \"https://podolino-frontend.azurewebsites.net\"",
    "build:local": "NODE_ENV=development parcel build --target app --public-url \"http://localhost:3000\"",
    "build:local-win": "set NODE_ENV=development && env-cmd -f ./.env parcel build --target app --public-url \"http://localhost:3000\"",
    "build:host": "NODE_ENV=development parcel build --target app --public-url \"http://192.168.178.72:3000\"",
    "build:azure:static": "NODE_ENV=production parcel build --target app --public-url \"https://swfootprintwebdrivergwc.blob.core.windows.net/static\"",
    "serve-dist:host": "npm run build:host && http-server ./dist -p 3000 -a 192.168.178.72 --cors",
    "serve-dist": "npm run build:local && http-server ./dist -p 3000 --cors",
    "serve-dist-win": "env-cmd -f ./.env npm run build:local-win && http-server ./dist -p 3000 --cors",
    "deploy:testing": "npm run build:testing && aws s3 sync --acl private --sse --delete ./dist s3://website-testing-frontend.podolino.de && aws cloudfront create-invalidation --distribution-id E1Z1EIKC8NAPW1 --paths '/*'",
    "deploy:testing-win": "npm run build:testing-win && aws s3 sync --acl private --sse --delete ./dist s3://website-testing-frontend.podolino.de && aws cloudfront create-invalidation --distribution-id E1Z1EIKC8NAPW1 --paths '/*'",
    "deploy:production": "npm run build:production && aws s3 sync --acl private --sse --delete ./dist s3://website-production-frontend.footprinttech.de && aws cloudfront create-invalidation --distribution-id E3IN41JHU3TKUJ --paths '/*'"
  },
  "browserslist": {
    "production": [
      ">0.2%",
      "not dead",
      "not op_mini all"
    ],
    "development": [
      "last 1 chrome version",
      "last 1 firefox version",
      "last 1 safari version"
    ]
  },
  "devDependencies": {
    "@babel/core": "^7.24.6",
    "@babel/preset-env": "^7.12.1",
    "@babel/preset-react": "^7.12.5",
    "@babel/preset-typescript": "^7.12.1",
    "@parcel/config-default": "2.13.0",
    "@parcel/core": "2.13.0",
    "@parcel/transformer-raw": "2.13.0",
    "@parcel/transformer-typescript-tsc": "2.13.0",
    "@types/node": "22.9.x",
    "@types/react": "19.2.x",
    "@types/react-dom": "19.2.x",
    "@types/styled-components": "^5.1.4",
    "@typescript-eslint/eslint-plugin": "8.14.x",
    "@typescript-eslint/parser": "8.14.0",
    "autoprefixer": "^10.4.16",
    "babel-loader": "^9.1.0",
    "babel-plugin-styled-components": "^2.0.2",
    "buffer": "^6.0.3",
    "eslint": "9.15.x",
    "eslint-plugin-import": "^2.25.2",
    "eslint-plugin-jest": "^28.9.0",
    "eslint-plugin-react": "^7.37.2",
    "http-server": "^14.1.0",
    "parcel": "2.13.0",
    "postcss": "^8.0.0",
    "process": "^0.11.10",
    "rollup": "4.x.x",
    "source-map": "^0.7.4",
    "svgo": "2.x.x",
    "typescript": "5.6.x"
  },
  "targets": {
    "app": {}
  },
  "@parcel/transformer-css": {
    "cssModules": true
  },
  "jest": {
    "moduleNameMapper": {
      ".+\\.(css|scss)$": "identity-obj-proxy",
      "^.+\\.(jpg|jpeg|png|gif|eot|otf|webp|svg|ttf|woff|woff2|mp4|webm|wav|mp3|m4a|aac|oga)$": "<rootDir>/__mocks__/fileMock.js"
    }
  },
  "packageManager": "yarn@1.22.22+sha512.a6b2f7906b721bba3d67d4aff083df04dad64c399707841b7acf00f6b133b7ac24255f2652fa22ae3534329dc6180534e98d17432037ff6fd140556e2bb3137e"
}
